import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './accounting.component.html'
})
export class AccountingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
